export default __webpack_public_path__ + "static/media/tasset_of_the_doomsayer.1eeca4d8.jpg";